import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { normalizeAddress } from "../../../anyspend/utils/index.js";
import { base } from "viem/chains";
import { AnySpendCustomExactIn } from "./AnySpendCustomExactIn.js";
const STAKE_FOR_FUNCTION_ABI = JSON.stringify([
    {
        name: "stakeFor",
        type: "function",
        stateMutability: "nonpayable",
        inputs: [
            { name: "user", type: "address" },
            { name: "amount", type: "uint256" },
        ],
        outputs: [],
    },
]);
export function AnySpendStakeUpsideExactIn({ loadOrder, mode = "modal", recipientAddress, sourceTokenAddress, sourceTokenChainId, destinationTokenAmount, stakingContractAddress, token, onSuccess, senderAddress, showFiatOption, slots, content, theme, }) {
    if (!recipientAddress)
        return null;
    const header = () => (_jsx(_Fragment, { children: _jsx("div", { className: "from-b3-react-background to-as-on-surface-1 w-full rounded-t-lg bg-gradient-to-t", children: _jsx("div", { className: "mb-1 flex w-full flex-col items-center gap-2", children: _jsxs("span", { className: "font-sf-rounded text-2xl font-semibold", children: ["Swap & Stake ", token.symbol, " (Exact In)"] }) }) }) }));
    const customExactInConfig = {
        functionAbi: STAKE_FOR_FUNCTION_ABI,
        functionName: "stakeFor",
        functionArgs: [normalizeAddress(recipientAddress), "{{amount_out}}"],
        to: stakingContractAddress,
        spenderAddress: stakingContractAddress,
        action: `stake ${token.symbol}`,
    };
    return (_jsx(AnySpendCustomExactIn, { loadOrder: loadOrder, mode: mode, recipientAddress: recipientAddress, sourceTokenAddress: sourceTokenAddress, sourceTokenChainId: sourceTokenChainId, destinationToken: token, destinationChainId: base.id, destinationTokenAmount: destinationTokenAmount, customExactInConfig: customExactInConfig, header: header, onSuccess: onSuccess, senderAddress: senderAddress, showFiatOption: showFiatOption, slots: slots, content: content, theme: theme }));
}
